import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { Audience } from './audience'
import type { PreviewOrGenerateAudienceDto } from './dto/audience-preview-generate.dto'
import type { CreateStaticAudienceDto } from './dto/create-static-audience.dto'

export class AudiencesRepository extends BaseRepository<Audience> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.eventApiUrl + '/' + 'audiences', token, cache)
    }

    async getPreview(dto: PreviewOrGenerateAudienceDto) {
        const { json, statusCode, message } = await this.request.post(
            this.config.eventApiUrl + '/audiences/preview/?token=' + this.resolvedToken,
            dto,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async generateAudience(audienceId: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.eventApiUrl + '/audiences/' + audienceId + '/generate/?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async createStaticAudience(dto: CreateStaticAudienceDto) {
        const { json, statusCode, message } = await this.request.post(
            this.config.eventApiUrl + '/audiences/static?token=' + this.resolvedToken,
            dto,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async addPersonToAudience(audienceId: string, personId: string) {
        const { json, statusCode, message } = await this.request.post(
            this.config.eventApiUrl + '/audiences/' + audienceId + '/persons/?token=' + this.resolvedToken,
            { personId },
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async removeFromAudience(audienceId: string, personId: string) {
        const { json, statusCode, message } = await this.request.delete(
            this.config.eventApiUrl + '/audiences/' + audienceId + '/persons/?token=' + this.resolvedToken,
            { personId },
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
